module.exports = __webpack_public_path__ + "img/hr-train-wheels-5.c7f59608.png";